export const GET_ALL_DETAILS_SUCCESS = 'GET_ALL_DETAILS_SUCCESS'

